export default __webpack_public_path__ + "static/media/python.b0f8dfaf.png";